/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgResearchRequestDto
 */
export interface OrgResearchRequestDto {
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    orgId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    legalCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    legalEntityName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    lei?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    dbaOrBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    altBusiness?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    ein?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    contactPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    contactEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    stockExchange?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    stockSymbol?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchRequestDto
     */
    verticalServed?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OrgResearchRequestDto
     */
    parameters?: { [key: string]: string; };
}

/**
 * Check if a given object implements the OrgResearchRequestDto interface.
 */
export function instanceOfOrgResearchRequestDto(value: object): boolean {
    return true;
}

export function OrgResearchRequestDtoFromJSON(json: any): OrgResearchRequestDto {
    return OrgResearchRequestDtoFromJSONTyped(json, false);
}

export function OrgResearchRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgResearchRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'legalCompanyName': json['legalCompanyName'] == null ? undefined : json['legalCompanyName'],
        'legalEntityName': json['legalEntityName'] == null ? undefined : json['legalEntityName'],
        'status': json['status'] == null ? undefined : json['status'],
        'lei': json['lei'] == null ? undefined : json['lei'],
        'dbaOrBrandName': json['dbaOrBrandName'] == null ? undefined : json['dbaOrBrandName'],
        'website': json['website'] == null ? undefined : json['website'],
        'altBusiness': json['altBusiness'] == null ? undefined : json['altBusiness'],
        'address': json['address'] == null ? undefined : json['address'],
        'country': json['country'] == null ? undefined : json['country'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'ein': json['ein'] == null ? undefined : json['ein'],
        'contactPhone': json['contactPhone'] == null ? undefined : json['contactPhone'],
        'contactEmail': json['contactEmail'] == null ? undefined : json['contactEmail'],
        'stockExchange': json['stockExchange'] == null ? undefined : json['stockExchange'],
        'stockSymbol': json['stockSymbol'] == null ? undefined : json['stockSymbol'],
        'verticalServed': json['verticalServed'] == null ? undefined : json['verticalServed'],
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
    };
}

export function OrgResearchRequestDtoToJSON(value?: OrgResearchRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'orgId': value['orgId'],
        'legalCompanyName': value['legalCompanyName'],
        'legalEntityName': value['legalEntityName'],
        'status': value['status'],
        'lei': value['lei'],
        'dbaOrBrandName': value['dbaOrBrandName'],
        'website': value['website'],
        'altBusiness': value['altBusiness'],
        'address': value['address'],
        'country': value['country'],
        'postalCode': value['postalCode'],
        'city': value['city'],
        'state': value['state'],
        'ein': value['ein'],
        'contactPhone': value['contactPhone'],
        'contactEmail': value['contactEmail'],
        'stockExchange': value['stockExchange'],
        'stockSymbol': value['stockSymbol'],
        'verticalServed': value['verticalServed'],
        'parameters': value['parameters'],
    };
}

